// Only public category fields and their coupon terms are included by prebuild.
// Live API responses still replace this snapshot and determine availability.
import { isCouponLive } from './couponRules';

export function getLiveCatalogCoupons(catalogue, now = new Date()) {
  // Pass the date explicitly; Array.filter's second argument is an index.
  return catalogue.coupons.filter(coupon => isCouponLive(coupon, now));
}

export function readCatalogSnapshot() {
  try {
    const encoded = process.env.REACT_APP_BOOKING_CATALOG_SNAPSHOT;
    if (!encoded) return { categories: [], order: '', coupons: [] };
    const utf8 = Array.from(atob(encoded), char => '%' + char.charCodeAt(0).toString(16).padStart(2, '0')).join('');
    const value = JSON.parse(decodeURIComponent(utf8));
    return { categories: Array.isArray(value.categories) ? value.categories : [],
      order: value.order || '', coupons: Array.isArray(value.coupons) ? value.coupons : [] };
  } catch (_) {
    return { categories: [], order: '', coupons: [] };
  }
}
